import * as React              from "react";

import "./wizard-tool.scss";

import {cs}             from "@Common/react/chain-services";

export const WizardTool = ({children=null, tooltipCopy, onClickFunction}) => cs(

    ({}) => (
        <div className="wizard-tool-h74">
            <div className="tool-button" onClick={() => onClickFunction()}>
                {children}
            </div>
            <div className="wizard-tooltip">
                <div className="tooltip-body">
                    <p>{tooltipCopy}</p>
                </div>
                <div className= "tooltip-tail"/>
            </div>
        </div>
    )
)